export const phoneNumberMask = '(000) 000-0000';
export const verificationCodeMask = '000000';
